export default {
  path: '/trackers/overview/:id',
  name: 'TrackerView',
  component: () => import(/* webpackChunkName: "base" */ '../views/TrackerView.vue')
}
